import { doc, getDoc, getDocFromServer } from "firebase/firestore";
import { db } from "../../firebase";
import { GetServiceOpts, EntityGet, EntityServerGet } from "../../types";
import { Customer } from "./types";
import { transformMetadata, processTimestampFields } from "../../utils";

export type CustomerGetService<T> = (
  agentId: string,
  id: string,
  opts?: GetServiceOpts
) => Promise<T | null>;

const get: CustomerGetService<EntityGet<Customer>> = async (
  agentId,
  id,
  opts = {}
) => {
  const docRef = doc(db, `/agent/${agentId}/customer/${id}`);
  const { disableCache } = opts;
  const getFn = disableCache ? getDocFromServer : getDoc;
  const docSnap = await getFn(docRef);
  if (docSnap.exists()) {
    return processTimestampFields(
      transformMetadata({
        ...docSnap.data(),
        id: docSnap.id,
      } as EntityServerGet<Customer>)
    ) as EntityGet<Customer>;
  }
  return null;
};

export default get;
